import { baseApi } from './baseApi';

export const manualCallsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getManualCalls: builder.query({
      query: (params) => ({
        url: '/api/manual-calls',
        params: {
          page: 1,
          limit: 25,
          sortBy: 'callTimestamp',
          sortDir: 'desc',
          ...params,
        },
      }),
      providesTags: ['ManualCalls'],
      serializeQueryArgs: ({ queryArgs }) => {
        const { page, ...rest } = queryArgs || {};
        return JSON.stringify(rest);
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page === 1) {
          return newItems;
        }
        return {
          ...newItems,
          data: [...(currentCache?.data || []), ...newItems.data],
        };
      },
      forceRefetch: ({ currentArg, previousArg }) =>
        JSON.stringify(currentArg) !== JSON.stringify(previousArg),
    }),
  }),
});

export const { useGetManualCallsQuery, useLazyGetManualCallsQuery } = manualCallsApi;
